<div class="row">
  <div class="col-md-6">
        <h4 class="heading_search_policies mt-1 ml-2">View all Policies and Quotes</h4>
  </div>
  <div class="col-md-6">
    <button style="float:right;margin-left: 15px;" name="DocumentBtn" id="DocumentBtnID"
        class="btn btn-small btn_create_policy_quotes mt-2" (click)="clickDocument()">
        <i name="DocumentBtnIcon" id="DocumentBtnIconID" class="fa fa-file"></i> &nbsp;
        Document Center
    </button>
    <button name="createQuote" style="float:right" id="createQuoteID" class="btn btn-small btn_create_policy_quotes mt-2 ml-2" (click)="CreateOnlineQuote()">
      <i name="createQuoteIcon" id="createQuoteIconID" class="fa fa-plus-circle"></i> &nbsp;
      Create New Online Quote</button>
  </div>
</div>
<div class="ml-2">
    <form #productForm="ngForm" style="width:100%">
        <div class="main_content mt-1">
            <div class="row mt-0">
                <div class="col-lg-12 mt-1">
                    <p-tabView styleClass="tabview-custom" (onChange)="quotestab = !quotestab">
                        <p-tabPanel header="policies">
                            <ng-template pTemplate="header">
                                <!-- <i class="pi pi-home mr-2"></i> -->
                                <span>Policies</span>
                            </ng-template>
                            <app-search-policies *ngIf="!quotestab" ></app-search-policies>
                        </p-tabPanel>
                        <p-tabPanel header="quotes">
                            <ng-template pTemplate="header">
                                <!-- <i class="pi pi-file mr-2"></i> -->
                                <span>Quotes</span>
                            </ng-template>
                            <app-search-quotes *ngIf="quotestab"></app-search-quotes>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
        </div>
    </form>
</div>

